import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=bdc7098c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=bdc7098c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc7098c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc7098c')) {
      api.createRecord('bdc7098c', component.options)
    } else {
      api.reload('bdc7098c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=bdc7098c&scoped=true&", function () {
      api.rerender('bdc7098c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tCSgwwHD1ZS6/JS/comp/DateRangeExt.vue"
export default component.exports